<div class="limiter">
  <div class="container-login100">
    <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <div class="row">
      <div class="col-md-8 col-sm-8 col-8">
        <div class="form-group">
          <label class="text-danger"> Password </label>
          <input class="form-control" type="password" />
        </div>
      </div>
      <div class="col-md-8 col-sm-8 col-8">
        <div class="form-group">
          <label class="text-danger"> Confirm Password </label>
          <div class="input-group">
            <input class="form-control" type="password" />
            <div class="input-group-append">
              <span class="input-group-text cursor-pointer">
                <i
                  class="fa"
                  [ngClass]="{
                    'fa-eye-slash': !fieldTextType,
                    'fa-eye': fieldTextType
                  }"
                  (click)="fieldTextType = !fieldTextType"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-8 col-8">
        <button type="submit" class="btn-main-large">SUBMIT</button>
      </div>
    </div>
  </div>
</div>
